var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main",
    { staticClass: "pagina__conteudo" },
    [
      _c("Cabecalho", { attrs: { dados: _vm.DadosDoContrato } }),
      _vm._v(" "),
      _c("Conteudo", {
        attrs: {
          dadosDeCobranca: _vm.DadosDeCobranca,
          dadosDeNovacao: _vm.DadosDeNovacao
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d4907352", { render: render, staticRenderFns: staticRenderFns })
  }
}